import { defineStore } from "pinia"

export const useModalStore = defineStore('modal', () => {
    
    const recover = ref(false)


    return {
        recover
    }
})